import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

const parametrosRelatorio = (filtro = {}) => ({
	tipo: filtro.tipo || null,
	ano: filtro.ano || null,
	mes: filtro.mes || null,
	id_cooperativa: filtro.id_cooperativa || null,
	id_empresa: filtro.id_empresa || null,
	id_turma: filtro.id_turma || null
});

export function setModoTela(modo, registro = {}) {
    return {
        type: 'RELATORIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro

			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('funcionarioForm', {
			...registro,


		})
    ];
}

export function setFiltro(filtro) {
    return {
        type: 'RELATORIO_FILTRO',
        payload: filtro
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'RELATORIO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getListaCooperativa() {
    const request = axios.get(`${consts.API_URL}/cooperativa/listarSelect`);
    return {
        type: 'RELATORIO_COOPERATIVA_LISTADO',
        payload: request
    };
}

export function getListaEmpresa() {
    const request = axios.get(`${consts.API_URL}/empresa/listarSelect`);
    return {
        type: 'RELATORIO_EMPRESA_LISTADO',
        payload: request
    };
}

export function getListaTurma() {
    const request = axios.get(`${consts.API_URL}/turma/listarSelect`);
    return {
        type: 'RELATORIO_TURMA_LISTADO',
        payload: request
    };
}

export function getListaRelatorioPresencaPorCooperativa(filtro) {
console.log(filtro);

	return (dispatch, getState) => {

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioPresencaPorCooperativa?padrao=true
			&tipo=${filtro.tipo || null}
			&ano=${filtro.ano || null}
			&mes=${filtro.mes || null}
			&id_cooperativa=${filtro.id_cooperativa || null}
			&id_empresa=${filtro.id_empresa || null}
			&id_turma=${filtro.id_turma ||  null}
		`)
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_COOPERATIVA_LISTADO',
				payload: resp
			});
		}).catch(ex => {

		});
	}
}

export function getListaRelatorioPresencaPorEmpresa(filtro) {

	return (dispatch, getState) => {

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioPresencaPorEmpresa?padrao=true
			&tipo=${filtro.tipo || null}
			&ano=${filtro.ano || null}
			&mes=${filtro.mes || null}
			&id_cooperativa=${filtro.id_cooperativa || null}
			&id_empresa=${filtro.id_empresa || null}
			&id_turma=${filtro.id_turma ||  null}
		`)
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_EMPRESA_LISTADO',
				payload: resp
			});
		}).catch(ex => {

		});
	}
}

export function getListaRelatorioPresencaPorTurma(filtro) {

	return (dispatch, getState) => {

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioPresencaPorTurma?padrao=true
			&tipo=${filtro.tipo || null}
			&ano=${filtro.ano || null}
			&mes=${filtro.mes || null}
			&id_cooperativa=${filtro.id_cooperativa || null}
			&id_empresa=${filtro.id_empresa || null}
			&id_turma=${filtro.id_turma ||  null}
		`)
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_PRESENCA_POR_TURMA_LISTADO',
				payload: resp
			});
		}).catch(ex => {

		});
	}
}

export function getListaRelatorioNuncaParticiparam(filtro) {

	return (dispatch, getState) => {

	    axios.get(`${consts.API_URL}/funcionario/listarRelatorioNuncaParticiparam?padrao=true
			&tipo=${filtro.tipo || null}
			&ano=${filtro.ano || null}
			&mes=${filtro.mes || null}
			&id_cooperativa=${filtro.id_cooperativa || null}
			&id_empresa=${filtro.id_empresa || null}
			&id_turma=${filtro.id_turma ||  null}
		`)
		.then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_NUNCA_PARTICIPAM_LISTADO',
				payload: resp
			});
		}).catch(ex => {

		});
	}
}

export function getListaRelatorioJustificativas(filtro) {
	return dispatch => {
		dispatch({
			type: 'FUNCIONARIO_RELATORIO_JUSTIFICATIVAS_LISTADO',
			payload: { data: [] }
		});

		axios.get(`${consts.API_URL}/funcionario/listarRelatorioJustificativas`, {
			params: parametrosRelatorio(filtro)
		}).then(resp => {
			dispatch({
				type: 'FUNCIONARIO_RELATORIO_JUSTIFICATIVAS_LISTADO',
				payload: resp
			});
		}).catch(ex => {
			if (ex && ex.response) setErroAPI(ex);
		});
	};
}
